// 实人认证相关接口

const state = {
  authInfo: null, // 认证信息
  authStatus: null, // 认证状态: pending(申请认证), approved(通过认证), rejected(认证失败)
  isExamPass: false, // 是否通过考试（以后端 kvpair 为准）
  examLevel: '102',
}

const getters = {
  // 是否已通过认证
  isApproved: state => state.authStatus === 'approved',
  // 是否认证中
  isPending: state => state.authStatus === 'pending',
  // 是否认证失败
  isRejected: state => state.authStatus === 'rejected',
}

const mutations = {
  // 设置认证信息
  SET_AUTH_INFO (state, data) {
    state.authInfo = data
    state.authStatus = data?.raStatus || null
    if (data?.raStatus === 'approved' || window.vueApp.$store.state.isTest) {
      state.isExamPass = true
    }
    // state.authStatus = 'approved'
  },
  setIsExamPass (state, v) {
    state.isExamPass = v
  },
}

const actions = {
  // 保存实人认证信息
  save ({ rootState }, params) {
    return rootState.axios.post('/realppl/v1frontend/realppl-auth/save', params, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  // 初始化阿里云实人认证人脸核验
  cloudauthInitFaceVerify ({ rootState }, params) {
    return rootState.axios.post('/realppl/v1frontend/realppl-auth/cloudauth-init-face-verify', params)
  },

  // 查看实人认证信息
  async view ({ rootState, commit }) {
    const res = await rootState.axios.get('/realppl/v1frontend/realppl-auth/view')
    if (res.data.model) {
      commit('SET_AUTH_INFO', res.data.model)
    }
    return res
  },

  // 保存考试通过状态到后端 kvpair
  async saveExamPass ({ rootState, commit }, isPass = true) {
    await rootState.axios.post('/jye/v1frontend/jye/save-kvpair', {
      key: 'prohibitedGoodsExam',
      value: { isExamPass: isPass ? '1' : '0' },
    })
    commit('setIsExamPass', isPass)
  },

  // 从后端 kvpair 拉取考试通过状态；兼容老数据：若后端未记录但本地 localStorage 有通过记录，则迁移一次
  async viewExamPass ({ rootState, commit, dispatch }) {
    const res = await rootState.axios.get('/jye/v1frontend/jye/view-kvpair', {
      params: { key: 'prohibitedGoodsExam' },
    })
    const backendPassed = res.data.model?.kvpair?.isExamPass === '1'
    const localPassed = localStorage.getItem('realAuthIsExamPass') === '1'
    if (!backendPassed && localPassed) {
      await dispatch('saveExamPass', true)
    } else {
      commit('setIsExamPass', backendPassed)
    }
    localStorage.removeItem('realAuthIsExamPass')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
